// axios
import axios from 'axios'
import { getPortalSubdomainFromHostname } from '@/utils/portalGurudwara'

export const baseURL = process.env.VUE_APP_API_END_POINT
export const miraimindsBaseURL = process.env.VUE_APP_AI_MIRAIMINDS_API_END_POINT

const mainAPI = axios.create({ baseURL })
mainAPI.interceptors.request.use(config => {
  const accessToken = localStorage.getItem('accessToken')
  if (accessToken) {
    config.headers.Authorization = `Bearer ${accessToken}`
  }
  const portalSubdomain = getPortalSubdomainFromHostname()
  if (portalSubdomain) {
    config.headers['X-Admin-Portal'] = portalSubdomain
  }
  return config
})

export const miraimindsAPI = axios.create({
  baseURL: miraimindsBaseURL,
  headers: {
    'x-token': `${process.env.VUE_APP_AI_MIRAIMINDS_API_TOKEN}`
  }
})

export default mainAPI
